import '../styles/style.scss';
import { AmpStoryPlayer } from '../lib/ampStoryPlayer.js';

const RefappAmp = {
  // INFO: Vue 2.x hook
  inserted(el, binding) {
    RefappAmp.mounted(el, binding);
  },

  // INFO: Vue 3.x hook
  mounted(el, binding) {
    const { target, storyPageId = 'page-0' } = binding.value || {};

    new AmpStoryPlayer({ el, target, storyPageId }).init();
  },
};

export default RefappAmp;
